const APP_CHAIN = import.meta.env.VITE_CHAIN;

let tokens = {
  ["MAINNET"]: {
    // the swap opens as vUSDT -> KOIN, buying KOIN (helpers/initialize.js), unless the URL names other tokens
    send: {
      name: "Vortex USDT",
      symbol: "vUSDT",
      description: "Wrapped Tether USD via Vortex.",
      decimals: "8",
      logoURI:
        "https://raw.githubusercontent.com/koindx/token-list/main/src/images/mainnet/12VoHz41a4HtfiyhTWbg9RXqGMRbYk6pXh.png",
      address: "12VoHz41a4HtfiyhTWbg9RXqGMRbYk6pXh",
      allowance: true,
      token_website: "https://vortexbridge.io",
      coingecko_id: "",
      coinmarketcap_id: "",
    },
    received: {
      name: "Koin",
      symbol: "KOIN",
      description: "Native token of Koinos.",
      decimals: "8",
      logoURI: "https://raw.githubusercontent.com/koindx/token-list/main/src/images/mainnet/koin.png",
      address: "koin",
      allowance: false,
      token_website: "https://koinos.io",
      coingecko_id: "",
      coinmarketcap_id: "",
    },
    nameservices: {
      koin: "19GYjDBVXU7keLbYvMLazsGQn3GTWHjHkK",
      vhp: "12Y5vW6gk8GceH53YfRkRre2Rrcsgw7Naq",
    },
    trade: [
      {
        name: "Koin",
        symbol: "KOIN",
        description: "Native token of Koinos.",
        decimals: "8",
        logoURI: "https://raw.githubusercontent.com/koindx/token-list/main/src/images/mainnet/koin.png",
        address: "koin",
        allowance: false,
        token_website: "https://koinos.io",
        coingecko_id: "",
        coinmarketcap_id: "",
      },
      {
        name: "Vortex ETH",
        symbol: "vETH",
        description: "Wrapped Ethereum via Vortex.",
        decimals: "8",
        logoURI:
          "https://raw.githubusercontent.com/koindx/token-list/main/src/images/mainnet/1Tf1QKv3gVYLjq34yURSHw5ErTYbFjqTG.png",
        address: "1Tf1QKv3gVYLjq34yURSHw5ErTYbFjqTG",
        allowance: true,
        token_website: "https://vortexbridge.io",
        coingecko_id: "",
        coinmarketcap_id: "",
      },
      {
        name: "Vortex USDT",
        symbol: "vUSDT",
        description: "Wrapped Tether USD via Vortex.",
        decimals: "8",
        logoURI:
          "https://raw.githubusercontent.com/koindx/token-list/main/src/images/mainnet/12VoHz41a4HtfiyhTWbg9RXqGMRbYk6pXh.png",
        address: "12VoHz41a4HtfiyhTWbg9RXqGMRbYk6pXh",
        allowance: true,
        token_website: "https://vortexbridge.io",
        coingecko_id: "",
        coinmarketcap_id: "",
      },
      {
        name: "Vortex USDC",
        symbol: "vUSDC",
        description: "Wrapped USD Coin via Vortex.",
        decimals: "8",
        logoURI:
          "https://raw.githubusercontent.com/koindx/token-list/main/src/images/mainnet/1N8iYrYEJdCVK1rhbqv3qZUzHcpoeKmFnj.png",
        address: "1N8iYrYEJdCVK1rhbqv3qZUzHcpoeKmFnj",
        allowance: true,
        token_website: "https://vortexbridge.io",
        coingecko_id: "",
        coinmarketcap_id: "",
      },
    ],
  },
  ["HARBINGER"]: {
    send: {
      name: "tKoin",
      symbol: "TKOIN",
      description: "Native token of Koinos.",
      decimals: "8",
      logoURI:
        "https://raw.githubusercontent.com/koindx/token-list/main/src/images/harbinger/1FaSvLjQJsCJKq5ybmGsMMQs8RQYyVv8ju.png",
      address: "koin",
      allowance: true,
      token_website: "https://koinos.io",
      coingecko_id: "",
      coinmarketcap_id: "",
    },
    received: {
      name: "Virtual Hash Power",
      symbol: "VHP",
      description: "The fuel for producing blocks on Koinos.",
      decimals: "8",
      logoURI: "",
      address: "vhp",
      allowance: true,
      token_website: "https://koinos.io",
      coingecko_id: "",
      coinmarketcap_id: "",
    },
    nameservices: {
      koin: "1EdLyQ67LW6HVU1dWoceP4firtyz77e37Y",
      vhp: "12Y5vW6gk8GceH53YfRkRre2Rrcsgw7Naq",
    },
    trade: [
      {
        name: "Test Koin",
        symbol: "TKOIN",
        description: "Native token of Koinos.",
        decimals: "8",
        logoURI:
          "https://raw.githubusercontent.com/koindx/token-list/main/src/images/harbinger/1FaSvLjQJsCJKq5ybmGsMMQs8RQYyVv8ju.png",
        address: "koin",
        allowance: false,
        token_website: "https://koinos.io",
        coingecko_id: "",
        coinmarketcap_id: "",
      },
      {
        name: "Virtual Hash Power",
        symbol: "VHP",
        description: "The fuel for producing blocks on Koinos.",
        decimals: "8",
        logoURI: "",
        address: "vhp",
        allowance: false,
        token_website: "https://koinos.io",
        coingecko_id: "",
        coinmarketcap_id: "",
      },
    ],
  },
};

export const TOKENS_BASE = tokens[APP_CHAIN];
